import { Injectable } from '@angular/core';

export interface RevenueSummaryDataFormatted {
  timeDuration: string;
  totalSalesAmtAverage: string;
  salesDepositsCountAvg: string;
  creditsAmountAvg: string;
  creditsCountAvg: string;
  daysNegativeAvg: string;
  daysNegativeTotal: string;
  batchDays: string;
  nsfTransactionsAvg: string;
  nsfTransactionsTotal: string;
  balanceAvg: string;
  endingStatementBalanceMin: string;
  endingStatementBalanceAvg: string;
}

@Injectable({
  providedIn: 'root'
})
export class FormatBankValuesService {

  constructor() { }

  getBankValuesFormatted(bankValues): RevenueSummaryDataFormatted[] {
    const row1 = {
      timeDuration: '3 Mo Avg.',
      totalSalesAmtAverage: this.getValByAlias(bankValues, 'totaledSalesAmountAvg3Month'),
      salesDepositsCountAvg: this.getValByAlias(bankValues, 'salesDepositsCountAvg3Month'),
      creditsAmountAvg: this.getValByAlias(bankValues, 'creditsAmountAvg3Month'),
      creditsCountAvg: this.getValByAlias(bankValues, 'creditsCountAvg3Month'),
      daysNegativeAvg: this.getValByAlias(bankValues, 'daysNegativeAvg3Month'),
      daysNegativeTotal: this.getValByAlias(bankValues, 'daysNegativeTotal3Month'),
      batchDays: this.getValByAlias(bankValues, 'batchDaysCountAvg3Month'),
      nsfTransactionsAvg: this.getValByAlias(bankValues, 'nsfTransactionsAvg3Month'),
      nsfTransactionsTotal: this.getValByAlias(bankValues, 'nsfTransactionsTotal3Month'),
      balanceAvg: this.getValByAlias(bankValues, 'balanceAvg3Month'),
      endingStatementBalanceMin: this.getValByAlias(bankValues, 'endingStatementBalanceMin3Month'),
      endingStatementBalanceAvg: this.getValByAlias(bankValues, 'endingStatementBalanceAvg3Month'),
      numberMissingBankStatements3Month: this.getValByAlias(bankValues, 'numberMissingBankStatements3Month')
    };

    const row2 = {
      timeDuration: '6 Mo Avg.',
      totalSalesAmtAverage: this.getValByAlias(bankValues, 'totaledSalesAmountAvg6Month'),
      salesDepositsCountAvg: this.getValByAlias(bankValues, 'salesDepositsCountAvg6Month'),
      creditsAmountAvg: this.getValByAlias(bankValues, 'creditsAmountAvg6Month'),
      creditsCountAvg: this.getValByAlias(bankValues, 'creditsCountAvg6Month'),
      daysNegativeAvg: this.getValByAlias(bankValues, 'daysNegativeAvg6Month'),
      daysNegativeTotal: this.getValByAlias(bankValues, 'daysNegativeTotal6Month'),
      batchDays: this.getValByAlias(bankValues, 'batchDaysCountAvg3Month'),
      nsfTransactionsAvg: this.getValByAlias(bankValues, 'nsfTransactionsAvg6Month'),
      nsfTransactionsTotal: this.getValByAlias(bankValues, 'nsfTransactionsTotal6Month'),
      balanceAvg: this.getValByAlias(bankValues, 'balanceAvg6Month'),
      endingStatementBalanceMin: this.getValByAlias(bankValues, 'endingStatementBalanceMin6Month'),
      endingStatementBalanceAvg: this.getValByAlias(bankValues, 'endingStatementBalanceAvg6Month'),
      numberMissingBankStatements6Month: this.getValByAlias(bankValues, 'numberMissingBankStatements6Month')
    };

    return [row1, row2];
  }

  private getValByAlias(arr, alias) {
    return arr?.find(el => el.alias === alias)?.value ?? null;
  }
}
